/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { InformationCenterConfigurationModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class InformationCenterConfigurationsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsGetAll
   * @summary Returns the Info center configurations.
   * @request GET:/InformationCenterConfigurations
   */
  informationCenterConfigurationsGetAll = (params: RequestParams = {}) =>
    this.http.request<InformationCenterConfigurationModelDto[], any>({
      path: `/InformationCenterConfigurations`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsPost
   * @summary Creates the info center.
   * @request POST:/InformationCenterConfigurations
   */
  informationCenterConfigurationsPost = (
    data: InformationCenterConfigurationModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationCenterConfigurationModelDto, any>({
      path: `/InformationCenterConfigurations`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsDelete
   * @summary Deletes the information center for the specified Id.
   * @request DELETE:/InformationCenterConfigurations/{id}
   */
  informationCenterConfigurationsDelete = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/InformationCenterConfigurations/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsGet
   * @summary Returns the info center for the specified info center id.
   * @request GET:/InformationCenterConfigurations/{id}
   */
  informationCenterConfigurationsGet = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationCenterConfigurationModelDto, any>({
      path: `/InformationCenterConfigurations/${id}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsPut
   * @summary Updates the passed info center.
   * @request PUT:/InformationCenterConfigurations/{id}
   */
  informationCenterConfigurationsPut = (
    id: number,
    data: InformationCenterConfigurationModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<InformationCenterConfigurationModelDto, any>({
      path: `/InformationCenterConfigurations/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsResequence
   * @summary Returns the info center for the specified info center id.
   * @request GET:/InformationCenterConfigurations/Resequence
   */
  informationCenterConfigurationsResequence = (
    query?: {
      /**
       * Info center id.
       * @format int32
       */
      id?: number;
      /** up/down */
      direction?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<InformationCenterConfigurationModelDto[], any>({
      path: `/InformationCenterConfigurations/Resequence`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
